const tileData = [
  {
    img: 'https://images.pexels.com/photos/416676/pexels-photo-416676.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
    title: 'Image',
    author: 'author',
  },
];

export default tileData;